import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_ENDPOINT}/api/client`;

class ClientService {
    getAll() {
        return axios.get(`${API_URL}/all`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getActive() {
        return axios.get(`${API_URL}/active`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getClient(id) {
        return axios.get(`${API_URL}/view/${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getFilter(search) {
        return axios.get(`${API_URL}/getFilter`, {
            params: {
                search: search,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    add(client) {
        return axios.post(`${API_URL}/new`, client, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    update(client) {
        return axios.put(`${API_URL}/update`, client, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
}

export default new ClientService();